import { cn } from "@/lib/utils";

interface LocationTagProps {
  name: string;
  className?: string;
}

export function LocationTag({ name, className }: LocationTagProps) {
  return (
    <span className={cn("location-tag", className)}>
      {name}
    </span>
  );
}
